import React, { Component } from 'react';
import { Button, Form, Input, message, Icon } from 'antd';
import Cookies from "js-cookie";
import { post, config } from "../../axios";
import {API_employee_modifyPayPassword} from "../../axios/config";

const FormItem = Form.Item;
class UpdatePayPasswords extends Component {
    state = {
        loading: false,
        disabled: false, //禁用发送验证码
        countDown: false, //显示倒计时
        second: 60,
    }


    componentDidMount() {
        this.props.onRef(this)
    }

    reset = () => {
        this.props.form.resetFields();
    }
    updatePayPassword = () => { //修改密码
        let loginData = Cookies.get('loginData');
        loginData = JSON.parse(loginData);
        let id = loginData.id;
        let requestUrl = "";
        requestUrl = config.API_employee_modifyPayPassword;
        return { requestUrl, id };
    }

    handleSubmit = (e) => {

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                if (values.payPasswordNew === values.passwordNew1) {
                    delete values.passwordNew1;
                    let url = this.updatePayPassword();
                    values.id = url.id;
                    post({ url: url.requestUrl, data: values }).then(res => {

                        this.props.form.resetFields();
                        message.success('修改成功');
                        this.setState({ loading: false });
                        this.props.clickUpdate();
                    }).catch(err => {
                        message.error(err.message || '修改失败');
                        this.setState({ loading: false });
                    });

                } else {
                    message.error('两次密码输入不一致');
                    this.setState({ loading: false });
                }
            }
        });
    };

    render() {
        let { getFieldDecorator } = this.props.form;
        let { loading } = this.state;
        return (
            <div >
                <div className="login" style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,.3)",
                    zIndex: 999,
                    height: 'auto',
                    display: this.props.updatePayPasswordStatus ? "block" : "none"
                }}
                    onClick={this.props.clickUpdate}

                >
                    <div className="login-form" onClick={(e) => { e.stopPropagation() }}>
                        <div className="login-logo">
                            <span>修改支付密码</span>
                        </div>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem label="旧密码：" >
                                {getFieldDecorator('payPassword', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="输入旧密码" />
                                )}
                            </FormItem>
                            <FormItem label="新密码：">
                                
                                {getFieldDecorator('payPasswordNew', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="输入新密码" />
                                )}
                            </FormItem>
                            <FormItem label="确认密码：">
                                {getFieldDecorator('passwordNew1', {
                                    rules: [{ required: true, message: '请输入' }],
                                })(
                                    <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="再次新输入密码" />
                                )}
                            </FormItem>
                            <FormItem>
                                <Button loading={loading} type="primary" htmlType="submit" className="login-form-button" style={{ width: '100%', marginTop: '10px' }}>确定</Button>
                            </FormItem>
                        </Form>
                    </div>

                </div>
            </div>
        );
    }

    
}

export default UpdatePayPasswords = Form.create()(UpdatePayPasswords);


// WEBPACK FOOTER //
// ./src/page/pages/UpdatePayPasword.js